import { EntitySchema } from '@people-science/entity-core';
import { Organization } from './Organization';
import { StudyCategory } from './StudyCategory';
import { StudyParticipant } from './StudyParticipant';
import { StudyTemplate } from './StudyTemplate';
import { ScreenComponent } from './ScreenComponent';
import { FormTemplate } from './FormTemplate';

export enum StudyType {
  Consumer = 'Consumer',
  Sponsor = 'Sponsor'
}

export enum StudyStatus {
  Testing = 'Testing',
  ActiveRecruiting = 'Active, Recruiting',
  ActiveNotRecruiting = 'Active, Not Recruiting',
  Completed = 'Completed',
  Locked = 'Locked'
}

export interface PediatricAgeBand {
  minAge: number;
  maxAge: number;
}

export const PEDIATRIC_MAX_AGE = 17;

export interface StudyConfig {
  screenFailedMessageEnabled?: boolean;
  screenFailedSubject?: string;
  screenFailedBody?: string;
  assentRequired?: 'Yes' | 'No' | 'Waived';
  ageBands?: PediatricAgeBand[];
  pediatricSelfAuthenticationAllowed?: boolean;
  pediatricSelfAuthenticationMinAge?: number;
}

export interface Study {
  id: number;
  name: string;
  type: StudyType;
  studyLength?: number;
  category: StudyCategory;
  focusTemplate: string;
  goalTemplate: string;
  trackingTemplate: string;
  interventionTemplate: string;
  reportDescription?: string;
  description?: string;
  introduction?: string;
  backgroundImageUrl?: string;
  foregroundColor?: string;
  backgroundColor?: string;
  screenComponents: ScreenComponent<any>[];
  myDataComponents: ScreenComponent<any>[];
  ongoingStudyNotificationFormTemplateId: number;
  intakeFormTemplateId: number;
  intakeFormTemplate?: FormTemplate;
  qualificationFormTemplateId: number;
  qualificationFormTemplate?: FormTemplate;
  shareUrl?: string;
  isPublic?: boolean;
  allowSelfWithdraw?: boolean;
  isPediatric?: boolean;
  intakeEntityId: string; // The entity containing the intake form
  intakeEntity: EntitySchema;
  startDate: string;
  organization?: Organization;
  organizationId?: number;
  preferredNotificationTime: string;
  studyParticipants: StudyParticipant[];
  status?: StudyStatus;
  enableShareResult: boolean;
  config?: StudyConfig;
}
